import {Circle, Path, Svg} from 'react-native-svg';

const BigSearchIcon = () => (
  <Svg width="24" height="24" viewBox="0 0 36 36" fill="none">
    <Circle cx="14.8" cy="14.8" r="12.8" stroke="#8E8E93" strokeWidth="2.25" strokeLinecap="round" />
    <Path d="M33.9999 33.9999L24.3999 24.3999" stroke="#8E8E93" strokeWidth="2.25" strokeLinecap="round" />
  </Svg>
);

export default BigSearchIcon;
